import { List, Map } from 'immutable'

export default abstract class FormTrait {
  public state: Map<string, any>
  constructor() {}

  hasError(name: string): any {
    return typeof this.state.getIn(['validationErrors', name]) !== 'undefined'
  }
  getField(name: any[]): any {
    const field = this.state.getIn(['data', ...name])
    return typeof field !== 'undefined' ? field : ''
  }
  getError(name: string): any {
    return (this.state.getIn(['validationErrors', name]) as List<any>).get(0)
  }
}
